/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { putData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";

const TaskHeader = ({
  setDownloadExcel,
  setSearch,
  records,
  blockRefSelected,
}) => {
  const { setreloadTaskList, setSuccess, setError, setNotificationString } =
    useContext(GlobalProvider);

  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const { t } = useTranslation(); //for translation

  /* hook to get the search value */
  const [searchValue, setSearchValue] = useState("");

  /* function to click download xls*/
  const handleDownloadClick = () => {
    setDownloadExcel(true);
    setTimeout(() => setDownloadExcel(false), 500);
  };

  const refreshHandler = () => {
    setreloadTaskList(true);
    setSuccess(true);
    setNotificationString(t("The list has been refreshed successfully"));
  };

  //function for delete label
  const deleteTaskHandler = () => {
    const checkboxes = document.querySelectorAll(
      'input[name="selectTaskRecord"]'
    );

    checkboxes.forEach(async (checkbox) => {
      if (checkbox.checked) {
        try {
          let taskData = {
            status: "0",
          };

          let requestUrl =
            url.API_BASEURL +
            url.API_UPDATE_PROJECT_TASK +
            `/${checkbox.value}` +
            `?token=${token}`;

          const response = await putData(requestUrl, taskData);

          if (response.status) {
            setreloadTaskList(true);
            setSuccess(true);
            setNotificationString(t("Label has been deleted successfully"));
          }
        } catch (error) {
          console.error(error.message);
          setError(true);
          setNotificationString(
            t("Something went wrong, please try again later")
          );
        }
      }
    });
  };

  /* hook to empty search when searchValue gets empty */
  useEffect(() => {
    !searchValue && setSearch("");
  }, [searchValue]);

  return (
    <div className="filter-container d-flex flex-wrap align-items-center gap-2 pb-3 border-bottom border-gray">
      {/* <Link
        to="#columnCollapse"
        className="btn btn-primary mw-unset p-2"
        data-bs-toggle="collapse"
        role="button"
        aria-expanded="false"
        aria-controls="columnCollapse"
      >
        <span className="d-block material-symbols-outlined icon-fill">
          visibility
        </span>
      </Link> */}
      <Link
        onClick={handleDownloadClick}
        to="#"
        className="btn btn-primary mw-unset p-2"
      >
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={t("Download in Xls")}
          className="d-block material-symbols-outlined"
        >
          download
        </span>
      </Link>
      <div className="search-container position-relative d-none d-md-block">
        <form onSubmit={(e) => e.preventDefault()}>
          <input
            type="search"
            placeholder={t("Search here")}
            className="form-control bg-transparent py-2 border-0"
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={(e) => {
              e.key === "Enter" && (e.preventDefault(), setSearch(searchValue));
            }}
          />
          <button
            onClick={() => setSearch(searchValue)}
            type="button"
            className="bg-transparent text-dark p-0 border-0 position-absolute top-50 translate-middle-y"
          >
            <span className="d-block material-symbols-outlined">search</span>
          </button>
        </form>
      </div>
      {/* ------------- showing records start ----------------- */}
      <p className="text-gray fw-medium ms-auto me-3">
        {t("Showing")}
        <span className="text-black ms-1">{records}</span> {t("Records")} -
        <span className="text-black ms-1" ref={blockRefSelected}>
          {" "}
          0{" "}
        </span>{" "}
        {t("Selected")}
      </p>
      {/* ------------- showing records end ----------------- */}

      {/* ---------- refresh button start -------- */}
      <Link
        to="#"
        className="filter-btn btn btn-primary icon-btn mw-unset"
        onClick={refreshHandler}
      >
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={t("Refresh")}
          className="d-block material-symbols-outlined"
        >
          refresh
        </span>
      </Link>
      {/* ---------- refresh button end -------- */}
      <Link
        to="#filterCollapse"
        className="filter-btn btn btn-primary icon-btn mw-unset"
        data-bs-toggle="collapse"
        role="button"
        aria-expanded="false"
        aria-controls="filterCollapse"
      >
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={t("Filter")}
          className="d-block material-symbols-outlined"
        >
          filter_alt
        </span>
      </Link>
      <Link
        to="#add_task"
        data-bs-toggle="offcanvas"
        role="button"
        aria-controls="saveReservationPopup"
        className="filter-btn btn btn-primary icon-btn mw-unset"
      >
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={t("Add New task")}
          className="d-block material-symbols-outlined"
        >
          add
        </span>
      </Link>
      <div className="dropdown">
        <button
          className="btn btn-primary dropdown-toggle mw-unset"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {t("Actions")}
        </button>
        <ul className="dropdown-menu border-0 shadow-lg">
          <li>
            <Link
              className="dropdown-item"
              to="#tags_pnl"
              data-bs-toggle="offcanvas"
            >
              {t("Add Label")}
            </Link>
          </li>
          <li>
            <Link className="dropdown-item" to="#">
              {t("Download in Xls")}
            </Link>
          </li>
          <li>
            <Link className="dropdown-item" to="#" onClick={deleteTaskHandler}>
              {t("Delete selected")}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TaskHeader;
